import StyledTextField from 'components/commons/StyledTextField';
import InfoIcon from '@mui/icons-material/Info';
import { Box, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
const LabelWithTooltip = ({label, tooltip}) => (
    <Typography sx={{ display: 'flex', alignItems: 'center' }}>
        <span>
            {label}
        </span>
        {typeof tooltip === 'string' && tooltip.length > 0 && (
            <Tooltip
                title={tooltip}
                arrow
                placement="top"
                slotProps={{
                    tooltip: {
                        sx: {
                            maxWidth: 240,
                            lineHeight: 1.5,
                            fontSize: '11px',
                            padding: 1.5,
                        }
                    },
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', ml: 0.5, cursor: 'pointer' }}>
                    <InfoIcon fontSize="medium" sx={{ color: 'action.active', fontSize: '18px' }} />
                </Box>
            </Tooltip>
        )}
    </Typography>
);

const TextField = (props) => {
    let inputValue = props.params.inputProps.value;
    if ((props.params.inputProps.value?.toLowerCase() === 'min' || props.params.inputProps.value?.toLowerCase() === 'max')) {
        inputValue = '';
    }

    return (
        <StyledTextField
            {...props.params}
            inputProps={{
                ...props.params.inputProps,
                value: inputValue,
            }}
            label={
                props.tooltip
                    ? <LabelWithTooltip label={props.label} tooltip={props.tooltip}/>
                    : props.label
            }
            size="small"
            isHighlighted={props.isHighlighted}
            error={props.error}
            sx={{
                ...(props.tooltip ? {
                    '& fieldset legend > span': {
                        pr: 0,
                    },
                } : {}),
                ...props.inputStyle,
            }}
        />
    );
};

export default TextField;